import React from "react"
const Loader = () => {
  return (
    <div className="flex items-center justify-center">
      <div className="loadingio-spinner-rolling-2by998twmg8">
        <div className="ldio-yzaezf3dcmj">
          <div></div>
        </div>
      </div>
    </div>
  )
}

export default Loader
